/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Metadata for work blocked by a non-recoverable tool failure.
 */
export type EmployeeExecutionTerminalToolFailureBlocker = {
    /**
     * Deterministic blocker classification.
     */
    category: EmployeeExecutionTerminalToolFailureBlocker.category;
    /**
     * Sanitized human-readable explanation without raw tool output.
     */
    reason: string;
    /**
     * Tool that produced the terminal failure.
     */
    toolName: string;
    /**
     * Stable implementation-owned failure code.
     */
    failureCode: string;
    /**
     * ISO timestamp when the runtime determined that progress was blocked.
     */
    occurredAt: string;
};
export namespace EmployeeExecutionTerminalToolFailureBlocker {
    /**
     * Deterministic blocker classification.
     */
    export enum category {
        TERMINAL_TOOL_FAILURE = 'terminal-tool-failure',
    }
}

